// extracted by mini-css-extract-plugin
module.exports = {"user":"User_user__PQAEs","settingsicon":"User_settingsicon__2VOGT","menu":"User_menu__2g_QS","avatarImage":"User_avatarImage__1cEIp"};